module.exports = __webpack_public_path__ + "img/rank-bg.9ba20631.svg";